(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swa-allocation-buttons"] && !Shopify.designMode) return;
  try {
    const swaAudioMixer=()=>{
  if(window.SWA_AUDIO_MIX)return window.SWA_AUDIO_MIX;
  const Audio=window.AudioContext||window.webkitAudioContext;
  if(!Audio)return null;
  const context=new Audio();
  window.SWA_AUDIO_MIX={context};
  return window.SWA_AUDIO_MIX;
};

document.addEventListener('click',event=>{
  const button=event.target.closest(":is(buy-buttons button[type=\"submit\"], form[is=\"product-form\"] button[type=\"submit\"], .product-card__quick-buy button[aria-controls], button.uplinkly-sticky-cart-button, button.bogos-gift-item-add-btn, #slidecart-checkout-form button[name=\"checkout\"])");
  if(!button||button.disabled||button.getAttribute('aria-disabled')==='true')return;
  button.classList.remove('swa-press-flash');
  requestAnimationFrame(()=>button.classList.add('swa-press-flash'));
  setTimeout(()=>button.classList.remove('swa-press-flash'),600);
},true);

(() => {
  let context, enabled=true, last=0;
  try { enabled=localStorage.getItem('swa-interface-sound')!=='off'; } catch {}
  const template=document.getElementById('swa-sound-template');
  if(!template||document.getElementById('swa-sound-toggle'))return;
  const toggle=template.content.firstElementChild.cloneNode(true);
  (document.querySelector('main')||document.body).append(toggle);
  const paint=()=>{toggle.setAttribute('aria-pressed',String(enabled));toggle.textContent=enabled?toggle.dataset.on:toggle.dataset.off;};
  paint();
  const play=(kind)=>{
    if(!enabled)return;
    const now=performance.now();if(now-last<90&&!kind.startsWith('gift'))return;last=now;
    try {
      const Audio=window.AudioContext||window.webkitAudioContext;
      if(!Audio)return;
      context=context||swaAudioMixer()?.context;
      if(!context)return;
      const start=()=>{
        const t=context.currentTime;
        const bus=context.createGain(),filter=context.createBiquadFilter();
        bus.gain.value=.85;filter.type='lowpass';filter.frequency.value=2200;
        bus.connect(filter);filter.connect(context.destination);
        const echoes=[];
        for(const [delay,level] of [[.105,.18],[.23,.09],[.365,.04]]){
          const echo=context.createDelay(.5),gain=context.createGain();
          echo.delayTime.value=delay;gain.gain.value=level;
          filter.connect(echo);echo.connect(gain);gain.connect(context.destination);
          echoes.push(echo,gain);
        }
        const phrases={product:[[392,0]],button:[[392,0],[587.33,.085]],gift1:[[392,0],[493.88,.09],[587.33,.18]],gift2:[[392,0],[493.88,.07],[587.33,.14],[783.99,.23]],checkout:[[392,0],[493.88,.06],[587.33,.12],[783.99,.2],[987.77,.29]]};
        const notes=phrases[kind]||phrases.button;
        const duration=kind==='product'?.36:.7;
        const voice=(frequency,at,level)=>{
          const osc=context.createOscillator(),gain=context.createGain();
          osc.type='sine';osc.frequency.value=frequency;
          gain.gain.setValueAtTime(.0001,at);
          gain.gain.exponentialRampToValueAtTime(level,at+.016);
          gain.gain.exponentialRampToValueAtTime(.0001,at+duration);
          osc.connect(gain);gain.connect(bus);
          osc.start(at);osc.stop(at+duration+.025);
          osc.onended=()=>{osc.disconnect();gain.disconnect();};
        };
        notes.forEach(([frequency,delay])=>{
          voice(frequency,t+delay,.065/Math.sqrt(notes.length));
          voice(frequency*2,t+delay,.008/Math.sqrt(notes.length));
        });
        setTimeout(()=>{bus.disconnect();filter.disconnect();echoes.forEach(node=>node.disconnect());},1600);
      };
      if(context.state!=='running')context.resume().then(start).catch(()=>{});
      else start();
    } catch {}
  };

  toggle.addEventListener('click',()=>{
    enabled=!enabled;
    try{localStorage.setItem('swa-interface-sound',enabled?'on':'off');}catch{}
    paint();if(enabled)play('button');
  });
  window.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const target=event.target.closest('buy-buttons button[type="submit"],form[is="product-form"] button[type="submit"],button.uplinkly-sticky-cart-button,button.bogos-gift-item-add-btn,#slidecart-checkout-form button[name="checkout"],a[href*="/products/"]');
    if(!target||target.disabled||target.getAttribute('aria-disabled')==='true')return;
    if(target.matches('button.bogos-gift-item-add-btn')){
      if(document.querySelector('#freegifts-main-popup-container .swa-gift-pending'))return;
      const offer=window.FGSECOMAPP?.offers?.find(item=>String(item.id)===target.getAttribute('data-offer'));
      play(Number(offer?.giftsAvailable)>1?'gift1':'gift2');
      return;
    }
    play(target.closest('#slidecart-checkout-form')?'checkout':target.matches('a')?'product':'button');
  },true);
})();


(()=>{
  const template=document.getElementById('swa-music-template');
  if(!template||document.getElementById('swa-music-toggle'))return;
  const control=template.content.firstElementChild.cloneNode(true);
  const audio=document.createElement('audio');
  audio.id='swa-pdp-soundtrack';audio.preload='none';audio.loop=true;audio.volume=.12;audio.crossOrigin='anonymous';
  let musicSource,musicGain;
  control.hidden=true;
  (document.querySelector('main')||document.body).append(control);
  document.body.append(audio);
  let muted=false,state=null,position=0,requested=false,lastSaved=0;
  try{muted=localStorage.getItem('swa-music-muted')==='true';state=JSON.parse(sessionStorage.getItem('swa-music-position')||'null');}catch{}
  if(state?.source===control.dataset.src&&Number.isFinite(state.position))position=Math.max(0,state.position);
  const paint=()=>{const playing=!audio.paused&&!muted;control.textContent=playing?control.dataset.on:control.dataset.off;control.setAttribute('aria-pressed',String(playing));};
  const save=()=>{
    if(audio.readyState>=1&&Number.isFinite(audio.currentTime))position=audio.currentTime;
    try{sessionStorage.setItem('swa-music-position',JSON.stringify({source:control.dataset.src,position,active:requested&&!muted}));}catch{}
  };
  audio.addEventListener('loadedmetadata',()=>{
    if(Number.isFinite(audio.duration)&&audio.duration>0)audio.currentTime=position%audio.duration;
  });
  audio.addEventListener('play',()=>{paint();save();});
  audio.addEventListener('pause',()=>{paint();save();});
  audio.addEventListener('timeupdate',()=>{if(Date.now()-lastSaved>1000){lastSaved=Date.now();save();}});
  const start=()=>{
    if(muted)return;
    requested=true;
    try{
      const mixer=swaAudioMixer();
      if(mixer){
        if(!musicSource){
          musicSource=mixer.context.createMediaElementSource(audio);
          musicGain=mixer.context.createGain();musicGain.gain.value=.10;
          musicSource.connect(musicGain);musicGain.connect(mixer.context.destination);
          audio.volume=1;
        }
        if(mixer.context.state!=='running')void mixer.context.resume().catch(()=>{});
      }
    }catch{}
    if(!audio.src)audio.src=control.dataset.src;
    if(audio.paused)audio.play().then(paint).catch(()=>paint());
    save();
  };
  control.addEventListener('click',()=>{
    if(!audio.paused&&!muted){muted=true;requested=false;audio.pause();}
    else{muted=false;start();}
    try{localStorage.setItem('swa-music-muted',String(muted));}catch{}
    paint();save();
  });
  window.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const button=event.target.closest('buy-buttons button[type="submit"],button.uplinkly-sticky-cart-button');
    if(!button||button.disabled||button.getAttribute('aria-disabled')==='true'||button.closest('quick-buy-drawer'))return;
    control.hidden=false;
    start();
  },true);
  window.addEventListener('pagehide',save);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)save();});
  paint();

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swa-allocation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('swa-allocation')) {
    customElements.define('swa-allocation', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        if(this.onVisibility) document.removeEventListener('visibilitychange',this.onVisibility);
        this.clock = this.querySelector('[data-allocation-clock]');
        this.status = this.querySelector('[data-allocation-status]');
        this.dateLine = this.querySelector('[data-allocation-date]');
        const value = (this.dataset.deadline || '').trim();
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/);
        this.end = match ? Date.parse(value) : NaN;
        if (match) {
          const [, year, month, day, hour, minute, second] = match.map((v,i)=>i>0&&i<7?Number(v):v);
          const days = new Date(Date.UTC(year,month,0)).getUTCDate();
          if(month<1||month>12||day<1||day>days||hour>23||minute>59||second>59) this.end=NaN;
        }
        if (!Number.isFinite(this.end)) {
          this.dataset.state='pending';
          this.clock.hidden=false;
          this.dateLine.hidden=true;
          return;
        }
        const time = this.dateLine.querySelector('time');
        try {
          time.textContent = new Intl.DateTimeFormat(this.dataset.locale || 'en', {month:'short',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit',timeZone:this.dataset.timezone || 'UTC',timeZoneName:'short'}).format(this.end);
        } catch {
          time.textContent = new Date(this.end).toISOString();
        }
        this.dateLine.hidden=false;
        this.onVisibility = () => { this.stop(); if (!document.hidden && this.tick()) this.interval=setInterval(()=>this.tick(),1000); };
        document.addEventListener('visibilitychange',this.onVisibility);
        this.onVisibility();
      }
      tick() {
        const total=Math.max(0,Math.ceil((this.end-Date.now())/1000));
        if(total===0) {
          this.dataset.state='expired';
          this.clock.hidden=true;
          this.querySelector('[data-allocation-heading]').textContent=this.dataset.expired;
          this.status.textContent=this.dataset.expired;
          this.status.hidden=false;
          this.status.classList.add('sr-only');
          this.stop();
          return false;
        }
        this.dataset.state='active';
        this.clock.hidden=false;
        this.status.hidden=true;
        const values={days:Math.floor(total/86400),hours:Math.floor(total/3600)%24,minutes:Math.floor(total/60)%60,seconds:total%60};
        for(const [unit,n] of Object.entries(values)) this.roll(this.querySelector('[data-unit="'+unit+'"]'),String(n).padStart(2,'0'));
        return true;
      }
      roll(node,value){
        if(node.dataset.value===value)return;
        const previous=node.dataset.value;
        node.dataset.value=value;
        node.setAttribute('aria-label',value);
        node.getAnimations({subtree:true}).forEach(animation=>animation.cancel());
        const incoming=document.createElement('span');
        incoming.className='swa-allocation__digit';
        incoming.textContent=value;
        incoming.setAttribute('aria-hidden','true');
        node.replaceChildren(incoming);
        if(previous===undefined||matchMedia('(prefers-reduced-motion: reduce)').matches||document.hidden)return;
        const outgoing=document.createElement('span');
        outgoing.className='swa-allocation__digit swa-allocation__digit--out';
        outgoing.textContent=previous;
        outgoing.setAttribute('aria-hidden','true');
        node.append(outgoing);
        const timing={duration:460,easing:'cubic-bezier(.22,1,.36,1)'};
        incoming.animate([{transform:'translateY(100%)',opacity:0},{transform:'translateY(0)',opacity:1}],timing);
        const exit=outgoing.animate([{transform:'translateY(0)',opacity:1},{transform:'translateY(-100%)',opacity:0}],timing);
        exit.onfinish=()=>outgoing.remove();
      }
      stop(){ if(this.interval) clearInterval(this.interval); this.interval=null; }
      disconnectedCallback(){ this.stop(); if(this.onVisibility)document.removeEventListener('visibilitychange',this.onVisibility); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swa-one-more-heading"] && !Shopify.designMode) return;
  try {
    (()=>{
const copy=document.querySelector('#swa-one-more-copy')?.textContent;
const initial=document.querySelector('#swa-two-free-copy')?.textContent;
if(!copy||!initial)return;
const originals=new WeakMap();
let scheduled=false;
const update=()=>{
scheduled=false;
const popup=document.querySelector('#freegifts-main-popup-container');
const title=popup?.querySelector('#bogos-gift-popup-title');
if(!title)return;
const current=title.textContent.trim();
if(!originals.has(title)){
if(!/^Choose Your (?:Two|2) Free Sabers\.?$/i.test(current)&&current!==copy)return;
originals.set(title,current);
}
const ids=[...new Set([...popup.querySelectorAll('.btn-add-to-cart[data-offer]')].map(button=>button.getAttribute('data-offer')))];
const offer=ids.length===1?window.FGSECOMAPP?.offers?.find(item=>String(item.id)===ids[0]):null;
const desired=Number(offer?.giftsAvailable)===1?copy:initial;
if(title.textContent.trim()!==desired||!title.querySelector('.swa-gift-heading-number')){
const parts=desired.split(/([12])/);
const fragment=document.createDocumentFragment();
parts.forEach(part=>{
if(/^[12]$/.test(part)){const number=document.createElement('span');number.className='swa-gift-heading-number';number.textContent=part;fragment.appendChild(number)}
else fragment.appendChild(document.createTextNode(part));
});
title.replaceChildren(fragment);
}
};
const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update)}};
document.addEventListener('fg-gifts:show-slider',schedule);
document.addEventListener('fg-gifts:added',schedule);
const previousUpdated=window.SLIDECART_UPDATED;
window.SLIDECART_UPDATED=function(...args){const result=previousUpdated?.apply(this,args);schedule();return result};
new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true});
schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
